export const APP_NAME = 'tag_page_perseus';
